// eslint-disable-next-line max-len
export default function rotateAction(direction, ctxMain, canvasMain, copyCanvas, canvasCur, returnCurrentFrame) {
  const frameSrc = canvasMain.toDataURL('image/png');
  const frame = new Image();
  frame.src = frameSrc;
  ctxMain.save();
  ctxMain.clearRect(0, 0, canvasMain.width, canvasMain.height);
  ctxMain.translate(canvasMain.width / 2, canvasMain.width / 2);
  if (direction === 'right') ctxMain.rotate(90 * Math.PI / 180);
  if (direction === 'left') ctxMain.rotate(-90 * Math.PI / 180);
  ctxMain.drawImage(frame, -canvasMain.width / 2, -canvasMain.height / 2);
  ctxMain.restore();
  const frameSrc2 = canvasMain.toDataURL('image/png');
  const frame2 = new Image();
  frame2.src = frameSrc2;
  ctxMain.drawImage(frame2, 0, 0);
  copyCanvas(canvasMain, canvasCur(returnCurrentFrame()));
}
